export default __webpack_public_path__ + "static/media/screen8.254b4286.png";